export function target() {
  return this.module === 'OptinPopup';
}

export function migrate() {
  if (this.data.idsCRMNovas) {
    this.data.idsCRMNovas = this.data.idsCRMNovas.map((id) => {
      return typeof id === 'string' ? id : id.idCRMNovas;
    });
  }

  if (this.data.idsCRMExistentes) {
    this.data.idsCRMExistentes = this.data.idsCRMExistentes.map((id) => {
      return typeof id === 'string' ? id : id.idCRMExistentes;
    });
  }
}
